import React, { useState } from "react";
import MightyInput from "mighty-input";

import "./style.css";

export default function AnimatedInput({ value, ...props }) {
  const [hasChanges, setChanged] = useState();

  const render = next =>
    Array.from(next)
      .map((char, i) => (
        <span key={i} className={`animation-${getCharType(char)}`}>
          {char}
        </span>
      ))
      .concat(
        hasChanges
          ? []
          : [
              <span style={{ color: "#ccc" }} key="arrow" aria-hidden>
                👈 Type something
              </span>,
            ],
      );

  return (
    <MightyInput
      onUpdate={() => setChanged(true)}
      className="myInput"
      value={value}
      render={render}
      {...props}
    />
  );
}

function getCharType(char) {
  switch (char) {
    case "\ud83d\ude00":
      return "smiley";
    case "\ud83d\udc97":
      return "heart";
    default:
      return "char";
  }
}
